<div class="clr-form-control clr-row">
  <label class="clr-control-label clr-col-12 clr-col-md-4">Load from file</label>
  <div class="clr-control-container clr-col-12 clr-col-md-8">
    <div class="clr-input-wrapper">
      <input #importFileControl class="clr-input" type="file" [ngModel]="importValue" (ngModelChange)="updateImportFile($event)" [accept]="extensions"/>
    </div>
  </div>
</div>
